import { Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { takeUntil } from 'rxjs/operators';
import { Roles } from 'src/app/models/enums';
import { AppState } from 'src/app/store/app.state';
import { BaseComponent } from '../base-component/base.component';
import {EventStatus, RequestStatus} from '../../services/bpp.webapi/client';
import {StatusHelper} from '../../helpers/statuses-helper';
import { ConfigService } from 'src/app/config/config.service';

@Component({
  selector: 'app-additional-content',
  templateUrl: './additional-content-wrapper.component.html',
  styleUrls: ['./additional-content-wrapper.component.scss']
})
export class AdditionalContentWrapperComponent extends BaseComponent implements OnInit, OnDestroy {
  Roles = Roles;
  role: Roles;
  isLfp:boolean;
  isLoading = false;

  constructor(private store: Store<AppState>,private config :ConfigService) {
    super();
    this.isLfp = config.isLfp();
  }

  ngOnInit() {
    this.store.select(e => e.user)
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe(e => {
        this.isSpinner = e.loading;
        if (!e.loading && e.currentUser) {
          this.role = e.currentUser.role;
        }
      });
  }

  getLegendaColor(status: EventStatus | RequestStatus) {
    if (this.isLfp){
      return StatusHelper.getLfpRequestStatusColor(status as RequestStatus);
    }
    return StatusHelper.getStatusColor(status as EventStatus);
  }
}
